<script lang="ts">
  import { cn } from '@shared/utils';

  import { LabelKey } from '../configs/label-key';
  import { LabelVariant } from '../configs/status-variant';
  import { nameMap } from '../model/name-map';
  import { styleMap } from '../model/style-map';

  export let key: LabelKey;
  export let variant: LabelVariant = LabelVariant.Rounded;
</script>

<div
  class="{cn(
    'flex h-max w-fit whitespace-nowrap px-2.5 py-1 text-sm font-normal lg:text-xs',
    {
      'rounded-full': variant === LabelVariant.Rounded,
      rounded: variant === LabelVariant.Square,
    },
    styleMap[key],
  )}"
>
  {nameMap[key]}
</div>
